module.exports = __webpack_public_path__ + "static/media/396.f85399ae.jpg";